import React, { useEffect } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyGetdoctorQuery } from '../State/Api/AdddocApiSlice';


function DoctorView() {
    const navigate = useNavigate();
      const params = useLocation();
     
      const doctorId = params?.state?.id;
     
      const [fetchDoctor, { data: doctorData, isFetching, failed }] = useLazyGetdoctorQuery();
      useEffect(() => {
            if (doctorId) {
              fetchDoctor(doctorId);
            }
          }, [doctorId]);
    return (
        <>
            <div className="container-fluid">

                <button
                    className="d-flex align-items-center gap-2 text-muted border-0 bg-transparent"
                    style={{ width: "fit-content" }}
                >
                    <i
                        class="fa-solid fa-arrow-left"
                        style={{
                            backgroundColor: "lightgrey",
                            padding: "0.5rem",
                            borderRadius: "0.4rem",
                        }}
                        onClick={() => navigate("/Doctors")}
                    ></i>
                    <span style={{ fontSize: "0.7rem" }}>
                        Go back
                    </span>
                </button>

                <div style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }} className="col-12 mb-4 d-flex justify-content-between">

                    <div className="d-flex">
                        <h4 className='m-0 p-3'>
                            Doctor
                        </h4>

                    </div>

                    <div className='d-flex align-items-center justify-content-end gap-3'>
                        <div className='d-flex align-items-center gap-3'>
                            <div className="position-relative div-okij8ijj">
                                <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                                <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                                    <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row mb-3">

                        {doctorData && [doctorData].map((item,index)=>
                        <div className="col-4" key={index}>
                            <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3">
                                <div className="d-flex gap-3 border-bottom pb-3">
                                    <img style={{ width: "6rem",height:"6rem",borderRadius:'50%' }} src={item?.basicinfo?.imageURL} alt="" srcset="" />
                                    <div className="d-flex flex-column w-100">

                                        <div className="d-flex justify-content-between">
                                            <span className='fw-bold'>
                                                {item?.basicinfo?.fullname}
                                            </span>

                                            <span style={{ fontSize: "0.7rem", background: "#EDFDF1", padding: "0.4rem", borderRadius: "1rem" }}>
                                                {item?.basicinfo?.useruniqueid}
                                            </span>
                                        </div>

                                        <span style={{ fontSize: "0.6rem", color: "lightgrey" }}>
                                            Join In date 21 August 2020, 12:45 AM
                                        </span>

                                        <div className="d-flex justify-content-between mt-2 mb-2 w-100">
                                            <span style={{ fontSize: "0.7rem", background: "#EDFDF1", padding: "0.4rem", borderRadius: "1rem" }}>{item?.professionalinfo?.specialization}</span>
                                            <span style={{ fontSize: "0.7rem", background: "#F5F5F5", padding: "0.4rem", borderRadius: "1rem" }}>Status : <span className='fw-bold text-success'>AVAILABLE</span></span>
                                        </div>

                                    </div>
                                </div>

                                <div className="d-flex justify-content-between  pt-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <i class="fa-solid fa-phone fa-sm" style={{ color: "#2BC155" }}></i>
                                        <span style={{ fontSize: "0.7rem" }}>{item?.basicinfo?.phonenumber}</span>
                                    </div>

                                    <div className="d-flex align-items-center gap-2">
                                        <i class="fa-solid fa-location-dot fa-sm" style={{ color: "#F46B68" }}></i>
                                        <span style={{ fontSize: "0.7rem" }}>{item?.basicinfo?.office_clinicaddress}</span>
                                    </div>
                                </div>
                            </div>
                        </div>)}

                        <div className="col-8">
                            <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <span>
                                        Appointment
                                    </span>
                                    <button className='div-ButtonGreen' style={{ color: '#fff' }} onClick={() => navigate("/AddAppointment", { state: { showModal: true } })}>+ Make Appointment</button>
                                </div>
                                <hr style={{ borderTop: "grey 1px dashed" }} />
                            </div>
                        </div>

                        <div className="row mt-4">

                            <div className="col-6">
                                <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3">
                                    <div className="d-flex justify-content-between">
                                        <span>
                                            Treatment History
                                        </span>

                                        <div className="d-flex align-items-center gap-2 text-primary">
                                            <span>
                                                view all
                                            </span>
                                            <i class="fa-solid fa-chevron-right"></i>
                                        </div>
                                    </div>

                                    <hr style={{ borderTop: "grey 1px dashed" }} />



                                    <div className="d-flex flex-column" style={{ height: "15rem", overflowX: "scroll" }}>
                                        <div className="">
                                            <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                                <div className="d-flex align-items-center gap-3">
                                                    <img src="/Images/Group9.png" alt="" />
                                                    <span className="d-flex flex-column align-items-start">
                                                        <span className="m-1">Diabetes</span>
                                                        <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                                    </span>
                                                </div>

                                                <span className="d-flex flex-column align-items-start">
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Vikram</span></span>
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                                </span>
                                            </span>
                                        </div>

                                        <div className="">
                                            <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                                <div className="d-flex align-items-center gap-3">
                                                    <img src="/Images/Group9.png" alt="" />
                                                    <span className="d-flex flex-column align-items-start">
                                                        <span className="m-1">Diabetes</span>
                                                        <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                                    </span>
                                                </div>

                                                <span className="d-flex flex-column align-items-start">
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Kavita</span></span>
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                                </span>
                                            </span>
                                        </div>

                                        <div className="">
                                            <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                                <div className="d-flex align-items-center gap-3">
                                                    <img src="/Images/Group9.png" alt="" />
                                                    <span className="d-flex flex-column align-items-start">
                                                        <span className="m-1">Diabetes</span>
                                                        <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                                    </span>
                                                </div>

                                                <span className="d-flex flex-column align-items-start">
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Rohit</span></span>
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                                </span>
                                            </span>
                                        </div>

                                        <div className="">
                                            <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                                <div className="d-flex align-items-center gap-3">
                                                    <img src="/Images/Group9.png" alt="" />
                                                    <span className="d-flex flex-column align-items-start">
                                                        <span className="m-1">Diabetes</span>
                                                        <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                                    </span>
                                                </div>

                                                <span className="d-flex flex-column align-items-start">
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Neha</span></span>
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-6">
                                <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3">
                                    <div className="d-flex justify-content-between">
                                        <span>
                                            Patient Tests and Lab Reports
                                        </span>
                                        <div className="d-flex align-items-center gap-2 text-primary">
                                            <span>
                                                view all
                                            </span>
                                            <i class="fa-solid fa-chevron-right"></i>
                                        </div>
                                    </div>

                                    <hr style={{ borderTop: "grey 1px dashed" }} />

                                    <div className="d-flex flex-column" style={{ height: "15rem", overflowX: "scroll" }}>
                                        <div className="">
                                            <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                                <div className="d-flex align-items-center gap-3">
                                                    <span className='rounded-circle bg-danger' style={{ height: "2rem", width: "2rem" }}>
                                                    </span>
                                                    <span className="d-flex flex-column align-items-start">
                                                        <span className="m-1">Blood Test Results</span>
                                                        <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                                    </span>
                                                </div>

                                                <span className="d-flex flex-column align-items-start">
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR.  Deepak </span></span>
                                                    <span style={{ color: "#2BC155" }} className="mx-1">View Report</span>
                                                </span>
                                            </span>
                                        </div>

                                        <div className="">
                                            <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                                <div className="d-flex align-items-center gap-3">
                                                    <span className='rounded-circle bg-primary' style={{ height: "2rem", width: "2rem" }}>
                                                    </span>
                                                    <span className="d-flex flex-column align-items-start">
                                                        <span className="m-1">X-ray</span>
                                                        <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                                    </span>
                                                </div>

                                                <span className="d-flex flex-column align-items-start">
                                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Meera</span></span>
                                                    <span style={{ color: "#2BC155" }} className="mx-1">View Report</span>
                                                </span>
                                            </span>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>




            </div>
        </>
    )
}

export default DoctorView